import { Link } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import "App.sass";
import TrashIcon from "Assets/TrashIcon";

import DeleteGerminationTrayModal from "./DeleteGerminationTrayModal";
import { useGerminationTrayStore } from "Store/GerminationTrayStore";

const GerminationTrayCard = ({ trayId }: { trayId: string }) => {
  const germinationTray = useGerminationTrayStore((state) =>
    state.germinationTrays.find((tray) => tray._id === trayId)
  );
  const elementRef = useRef<HTMLDivElement>(null);

  const [displayDeleteButton, setDisplayDeleteButton] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [width, setWidth] = useState(0);


  useEffect(() => {
    const observer = new ResizeObserver(() => {
      if (elementRef.current) {
        setWidth(elementRef.current.clientWidth);
      }
    });

    if (elementRef.current) observer.observe(elementRef.current);

    return () => observer.disconnect();
  }, []);

  const marginLeft = () => {
    return width ? `${width / 2}px` : "0px";
  }

  if (!germinationTray) return null;
  return (
    <div
      className="max-w-[16em] flex-grow overflow-hidden shadow-lg rounded flex-wrap p-5 m-5 bg-lightgreen"
      onMouseEnter={() => setDisplayDeleteButton(true)}
      onMouseLeave={() => setDisplayDeleteButton(false)}
    >
      {displayDeleteButton && (
        <button
          onClick={() => { setShowDeleteModal(true); setDisplayDeleteButton(false) }}
          className="btn p-15 text-[red] bg-[red] circle absolute mt-[-60px]"
          style={{ marginLeft: marginLeft() }}
        >
          <TrashIcon />
        </button>
      )}

      <Link to={`/germinationTray/${germinationTray._id}`}>
        <h2 className="text-2xl pb-5">{germinationTray.name}</h2>
        <p>Plant Count: {germinationTray.plantingIds?.filter((id) => id).length}</p>
        <p>
          Grid Size: {germinationTray.width}x{germinationTray.height}
        </p>
      </Link>

      <DeleteGerminationTrayModal
        trayId={trayId}
        setShowDeleteModal={setShowDeleteModal}
        showDeleteModal={showDeleteModal} />
    </div>
  );
};

export default GerminationTrayCard;
